var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"label":"Label","auto-grow":"","value":"The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through.","hide-details":""}})}
var staticRenderFns = []

export { render, staticRenderFns }